module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Console Booking Details")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Booking No")]), _vm._v(" "), _c('th', [_vm._v("Booking Type")]), _vm._v(" "), _c('th', [_vm._v("Booking For")]), _vm._v(" "), _c('th', [_vm._v("Contract No")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v("POR")]), _vm._v(" "), _c('th', [_vm._v("POL")]), _vm._v(" "), _c('th', [_vm._v("POD")]), _vm._v(" "), _c('th', [_vm._v("Validity Start")]), _vm._v(" "), _c('th', [_vm._v("Validity End")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.consoleBookingData), function(booking, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(booking.Bookingno || booking.bookingNo || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.BookingType || booking.bookingType || booking.ActiveStatus || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.BookingFor || booking.bookingFor || booking.FromBooingResponse || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.Contractno || booking.contractNo || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.ClientName || booking.clientName || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.Branch || booking.branchName || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.Por || booking.por || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.Pol || booking.pol || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(booking.Pod || booking.pod || 'N/A'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(booking.ValidityStart || booking.validityStart)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(booking.ValidityEnd || booking.validityEnd)))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": booking.BookingStatus === 'Released' ?
          'success' :
          booking.BookingStatus === 'Un-Released' ?
          'warning' :
          'secondary'
      }
    }, [_vm._v(_vm._s(booking.BookingStatus || booking.status || 'N/A'))])], 1)])
  }), _vm._v(" "), (_vm.consoleBookingData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("\n                No data available\n              ")])]) : _vm._e()], 2)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab901648","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/ConsoleBookingSection.vue
// module id = 2831
// module chunks = 0